import { render, staticRenderFns } from "./bathChangeStatus.vue?vue&type=template&id=2bfc8c81&scoped=true"
import script from "./bathChangeStatus.vue?vue&type=script&lang=js"
export * from "./bathChangeStatus.vue?vue&type=script&lang=js"
import style0 from "./bathChangeStatus.vue?vue&type=style&index=0&id=2bfc8c81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfc8c81",
  null
  
)

export default component.exports